<template>
	<div class="CarouselResponsive" :class="classes">
		<!-- list goes here-->
		<template v-for="(item, index) in list">
			<a v-if="!showcase" :key="index" class="CarouselResponsive-slide" :href="item.href">
				<figure class="Media" :class="mediaClasses">
					<div class="Media-content">
						<img
							:alt="item.title + ' ML' + item.assetId"
							:src="mediaURL + item.assetId + '/320'"
							:srcset="
								mediaURL +
								item.assetId +
								'/160 160w,' +
								mediaURL +
								item.assetId +
								'/320 320w,' +
								mediaURL +
								item.assetId +
								'/480 480w,' +
								mediaURL +
								item.assetId +
								'/640 640w,' +
								mediaURL +
								item.assetId +
								'/900 900w,' +
								mediaURL +
								item.assetId +
								'/1200 1200w,' +
								mediaURL +
								item.assetId +
								'/1800 1800w,' +
								mediaURL +
								item.assetId +
								'/2400 2400w'
							"
							:sizes="'(max-width: 767px) ' + imageSizeMobile + ', ' + imageSizeDesktop"
							data-image-loaded
						/>
					</div>
					<!-- non showcase captions -->
					<figcaption class="Media-caption">
						<div v-if="item.cat == 'species'">
							<h4 class="Heading Heading--h5 u-margin-none">
								<span class="Heading-main">{{ item.comName }}</span>
								<span class="Heading-sub Heading-sub--inline Heading-sub--sci">{{ item.sciName }}</span>
							</h4>
						</div>
						<div v-if="item.cat == 'genus'">
							<h4 class="Heading Heading--h5 u-margin-none">
								<span class="Heading-main">{{ item.sciName }}</span>
								<span class="Heading-sub Heading-sub--inline"># species</span>
							</h4>
						</div>
						<div v-if="item.cat == 'subspecies'">
							<h4 class="Heading Heading--h5 u-margin-none">
								<span class="Heading-main">{{ item.sciName }}</span>
								<span class="Heading-sub Heading-sub--inline Button--link">
									<strong>+X</strong>
								</span>
							</h4>
						</div>
						<div v-if="item.cat == 'family'">
							<h4 class="Heading Heading--h5 u-margin-none">
								<span class="Heading-main SciName">{{ item.sciName }}</span>
							</h4>
						</div>
						<span v-if="item.text" class="u-text-2 CarouselResponsive-caption-text">{{ item.text }}</span>
						<span v-if="item.badge" class="Badge Badge--small Badge--new">{{ item.badge }}</span>
					</figcaption>
				</figure>
			</a>

			<!-- when showcase is true-->
			<div v-else :key="'showcase' + index" class="CarouselResponsive-slide" :class="showcaseSlideClasses(index)">
				<figure class="Media" :class="mediaClasses">
					<div class="Media-content">
						<div v-if="list.length" class="ImageAspectRatio ImageAspectRatio--fourByThree ImageAspectRatio--transparent">
							<a class="AspectRatioContent" :href="item.href">
								<img
									v-if="index == 0"
									:alt="item.title + ' ML' + item.assetId"
									:src="mediaURL + item.assetId + '/320'"
									:srcset="
										mediaURL +
										item.assetId +
										'/160 160w,' +
										mediaURL +
										item.assetId +
										'/320 320w,' +
										mediaURL +
										item.assetId +
										'/480 480w,' +
										mediaURL +
										item.assetId +
										'/640 640w,' +
										mediaURL +
										item.assetId +
										'/900 900w,' +
										mediaURL +
										item.assetId +
										'/1200 1200w,' +
										mediaURL +
										item.assetId +
										'/1800 1800w,' +
										mediaURL +
										item.assetId +
										'/2400 2400w'
									"
									:sizes="'(max-width: 767px) ' + imageSizeMobile + ', ' + imageSizeDesktop"
									data-image-loaded
								/>
								<template v-else>
									<img
										v-if="item.assetFormatCode == 'photo'"
										:alt="item.title + ' ML' + item.assetId"
										:src="mediaURL + item.assetId + '/320'"
										:srcset="
											mediaURL +
											item.assetId +
											'/160 160w,' +
											mediaURL +
											item.assetId +
											'/320 320w,' +
											mediaURL +
											item.assetId +
											'/480 480w,' +
											mediaURL +
											item.assetId +
											'/640 640w,' +
											mediaURL +
											item.assetId +
											'/900 900w,' +
											mediaURL +
											item.assetId +
											'/1200 1200w,' +
											mediaURL +
											item.assetId +
											'/1800 1800w,' +
											mediaURL +
											item.assetId +
											'/2400 2400w'
										"
										:sizes="'(max-width: 767px) ' + imageSizeMobile + ', ' + imageSizeDesktop"
										data-image-loaded
									/>
									<!-- for when audio-->
									<img
										v-if="item.assetFormatCode == 'audio'"
										:alt="item.title + ' ML' + item.assetId"
										:src="mediaURL + item.assetId + '/poster'"
										:srcset="mediaURL + item.assetId + '/poster 160w,'"
										:sizes="'(max-width: 767px) ' + imageSizeMobile + ', ' + imageSizeDesktop"
										data-image-loaded
									/>

									<!-- for when video-->
									<img
										v-if="item.assetFormatCode == 'video'"
										:alt="item.title + ' ML' + item.assetId"
										:src="mediaURL + item.assetId + '/thumb'"
										:srcset="mediaURL + item.assetId + '/thumb 160w,'"
										:sizes="'(max-width: 767px) ' + imageSizeMobile + ', ' + imageSizeDesktop"
										data-image-loaded
									/>
								</template>
							</a>
						</div>
						<!-- only 1 in list -->
						<div v-else class="ImageAspectRatio ImageAspectRatio--sixteenByNine">
							<a class="AspectRatioContent" :href="item.href">
								<img
									v-if="index == 0"
									:alt="item.title + ' ML' + item.assetId"
									:src="mediaURL + item.assetId + '/320'"
									:srcset="
										mediaURL +
										item.assetId +
										'/160 160w,' +
										mediaURL +
										item.assetId +
										'/320 320w,' +
										mediaURL +
										item.assetId +
										'/480 480w,' +
										mediaURL +
										item.assetId +
										'/640 640w,' +
										mediaURL +
										item.assetId +
										'/900 900w,' +
										mediaURL +
										item.assetId +
										'/1200 1200w,' +
										mediaURL +
										item.assetId +
										'/1800 1800w,' +
										mediaURL +
										item.assetId +
										'/2400 2400w'
									"
									:sizes="'(max-width: 767px) ' + imageSizeMobile + ', ' + imageSizeDesktop"
									data-image-loaded
								/>
							</a>
						</div>
					</div>
					<!-- caption-->
					<figcaption class="Media-caption">
						<template v-if="item.assetFormatCode === 'photo'">
							<template v-if="index === 0">
								<!-- no title, but media credit for desktop -->
								<div
									class="MediaCredit MediaCredit--inline MediaCredit--reverse MediaCredit--sm u-margin-none u-showForMedium"
								>
									<span role="heading" level="4" class="MediaCredit-title MediaCredit-title--xs u-hideForMedium">{{
										item.title
									}}</span>
									<div class="MediaCredit-copyright">&copy;&nbsp;{{ item.userDisplayName }}</div>
									<ul class="InlineList InlineList-divided MediaCredit-links">
										<li>
											<a href class="u-linkPlain">Macaulay Library</a>
										</li>
										<li>
											<a href class="u-linkPlain">eBird</a>
										</li>
									</ul>
								</div>
								<!-- title for mobile -->
								<span role="heading" aria-level="4" class="MediaCredit-title MediaCredit-title--xs u-hideForMedium">{{
									item.title
								}}</span>
							</template>

							<!-- not first photo -->
							<template v-else>
								<!-- last photo with more hidden -->
								<strong v-if="index === visiblePhotoSlotCount - 1">
									<span class="u-inline-xs">
										<CloIcon symbol="photo" />
									</span>
									+{{ list.length - totalSlotCount + 1 }}
								</strong>
								<!-- normal title -->
								<span v-else role="heading" aria-level="4">{{ item.title }}</span>
							</template>
						</template>

						<!-- if audio-->
						<div v-if="item.assetFormatCode === 'audio'">
							<strong>
								<span class="u-inline-xs"> <CloIcon symbol="audio" /> </span>Listen
							</strong>
						</div>

						<!-- if video-->
						<div v-if="item.assetFormatCode === 'video'">
							<strong>
								<span class="u-inline-xs"> <CloIcon symbol="video" /> </span>Watch
							</strong>
						</div>
					</figcaption>
				</figure>
			</div>
		</template>
	</div>
</template>

<script>
import CloBadge from '@/base/CloBadge/CloBadge.vue';
import CloHeading from '@/base/CloHeading/CloHeading.vue';
import CloInlineList from '@/base/CloInlineList/CloInlineList.vue';
import CloMedia from '@/media/CloMedia/CloMedia.vue';
import CloImageAspectRatio from '@/media/CloImageAspectRatio/CloImageAspectRatio.vue';
import CloIcon from '@/icons/CloIcon/CloIcon.vue';

export default {
	components: { CloBadge, CloHeading, CloInlineList, CloMedia, CloImageAspectRatio, CloIcon },
	data() {
		return {
			mediaURL: 'https://cdn.download.ams.birds.cornell.edu/api/v1/asset/',
			totalSlotCount: 5,
		};
	},
	props: {
		/**
		Size the prop should have
		 */
		size: {
			type: String,
			default: '',
		},
		/**
		 * Small width property
		 */
		smallWidth: {
			type: String,
			default: '',
		},
		/**
		 * Medium width property
		 */
		mediumWidth: {
			type: String,
			default: '',
		},
		/**
		 * Large width property
		 */
		largeWidth: {
			type: String,
			default: '',
		},
		/**
		 * Whether component should be inline or not
		 */
		inline: {
			type: Boolean,
			default: false,
		},
		/**
		 * An array of arguments
		 */
		list: {
			type: Array,
			default() {
				return [];
			},
		},
		/**
		 * Whether to display the showcase section or not
		 */
		showcase: {
			type: Boolean,
			default: false,
		},
		/**
		 * Whether the variation contains an illustration or not
		 */
		illustration: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		visiblePhotoSlotCount: function () {
			let hasAudio = false;
			let hasVideo = false;
			let count = this.totalSlotCount;
			this.list.forEach((item) => {
				if (item.assetFormatCode === 'audio') {
					hasAudio = true;
				}
				if (item.assetFormatCode === 'video') {
					hasVideo = true;
				}
			});
			if (hasAudio) {
				count--;
			}
			if (hasVideo) {
				count--;
			}
			return count;
		},
		classes: function () {
			let prefix = 'CarouselResponsive--';
			let classes = [];
			if (this.size) {
				classes.push(prefix + this.size);
			}
			switch (this.smallWidth) {
				case 'partial':
					classes.push(prefix + 'sm-width80');
					break;
				case 'full':
					classes.push(prefix + 'sm-widthFull');
					break;
			}
			switch (this.mediumWidth) {
				case '1of3':
					classes.push(prefix + 'md-size1of3');
					break;
				case '1of4':
					classes.push(prefix + 'md-size1of4');
					break;
			}
			switch (this.largeWidth) {
				case '1of3':
					classes.push(prefix + 'lg-size1of3');
					break;
				case '1of4':
					classes.push(prefix + 'lg-size1of4');
					break;
			}
			if (this.inline) {
				classes.push(prefix + 'inline');
			}
			if (this.showcase) {
				classes.push(prefix + 'showcase');
			}
			let multimedia = false;
			this.list.forEach((item) => {
				if (item.assetFormatCode !== 'photo') {
					multimedia = true;
				}
			});
			if (multimedia) {
				classes.push(prefix + 'showcaseMultimedia');
			}
			if (this.illustration) {
				classes.push(prefix + 'illustrations');
			}
			return classes.join(' ');
		},
		mediaClasses: function () {
			if (this.inline) {
				return 'Media--flush u-margin-none';
			}
			if (this.showcase) {
				return 'Media--overlay';
			}
			if (this.illustration) {
				return 'Media--contained Media--dropshadow';
			}
		},
		imageSizeMobile: function () {
			let imageSize = '16rem';
			switch (this.size) {
				case 'xs':
					imageSize = '8rem';
					break;
				case 'sm':
					imageSize = '12rem';
					break;
				case 'lg':
					imageSize = '20rem';
					break;
				case 'xl':
					imageSize = '24rem';
					break;
			}
			switch (this.smallWidth) {
				case 'partial':
					imageSize = '80vw';
					break;
				case 'full':
					imageSize = '100vw';
					break;
			}
			switch (this.mediumWidth) {
				case '1of3':
					imageSize = '100vw';
					break;
				case '1of4':
					imageSize = '100vw';
					break;
			}
			switch (this.largeWidth) {
				case '1of3':
					imageSize = '100vw';
					break;
				case '1of4':
					imageSize = '100vw';
					break;
			}
			if (this.inline) {
				imageSize = '100vw';
			}
			return imageSize;
		},
		imageSizeDesktop: function () {
			let imageSize = '16rem';
			switch (this.size) {
				case 'xs':
					imageSize = '8rem';
					break;
				case 'sm':
					imageSize = '12rem';
					break;
				case 'lg':
					imageSize = '20rem';
					break;
				case 'xl':
					imageSize = '24rem';
					break;
			}
			switch (this.smallWidth) {
				case 'partial':
					imageSize = '16rem';
					break;
				case 'full':
					imageSize = '16rem';
					break;
			}
			switch (this.mediumWidth) {
				case '1of3':
					imageSize = '16rem';
					break;
				case '1of4':
					imageSize = '16rem';
					break;
			}
			switch (this.largeWidth) {
				case '1of3':
					imageSize = '16rem';
					break;
				case '1of4':
					imageSize = '16rem';
					break;
			}
			if (this.inline) {
				imageSize = '16rem';
			}
			if (this.showcase) {
				imageSize = '80vw';
			}
			return imageSize;
		},
	},
	methods: {
		showcaseSlideClasses(index) {
			let classes = [];
			if (index >= this.visiblePhotoSlotCount && this.list[index].assetFormatCode === 'photo') {
				classes.push('u-hideForMedium');
			}
			classes.push('CarouselResponsive-slide--' + this.list[index].assetFormatCode);
			return classes.join(' ');
		},
	},
};
</script>

<style lang="scss">
.CarouselResponsive {
	display: flex;
	flex-wrap: nowrap;
	overflow-x: auto;
	width: auto;
	scroll-snap-type: x mandatory;
	scroll-behavior: smooth;
	@include breakpoint(mediumsmall, down) {
		// hide the scrollbar
		scrollbar-width: none;
		-ms-overflow-style: none;
		&::-webkit-scrollbar {
			width: 0;
			height: 0;
		}
	}
	@include breakpoint(medium) {
		flex-wrap: wrap;
		overflow-x: unset;
		@supports (display: grid) {
			display: grid;
			grid-gap: $space-md;
			grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr));
		}
	}

	.CarouselResponsive-slide {
		margin: 0;
		padding: 0;
		scroll-snap-align: center;
		scroll-snap-stop: always;
		// default is medium size
		flex: 0 0 16rem;
		@include breakpoint(medium) {
			flex: 0 0 16rem;
		}
	}

	.CarouselResponsive-slide img {
		@supports (display: grid) {
			max-width: 100%;
			max-height: none;
		}
		height: auto;
		width: auto;
		opacity: 0;
		transition: opacity 0.3s ease;
		&[data-image-loaded] {
			opacity: 1;
		}
	}

	.CarouselResponsive-caption-text {
		@include text(2);
		color: $color-text-muted !important;
	}

	.CarouselResponsive-noMedia {
		@include text(2);
		color: $color-text-muted !important;
		height: 8rem;
		display: flex;
		align-items: center;
		justify-content: center;
	}
}

.CarouselResponsive--illustrations {
	background-color: $color-neutral-0;
	@include inset-xs;
	@include breakpoint(medium) {
		@supports (display: grid) {
			grid-gap: $space-xs;
		}
	}
	.CarouselResponsive-slide {
		transition: border-color 0.3s ease;
		transition-delay: 0.1s;
		border: 1px solid transparent;
		&:hover {
			border-color: $color-link;
		}
	}
}

.CarouselResponsive--inline {
	@include breakpoint(medium) {
		@supports (display: grid) {
			display: flex;
		}
		.CarouselResponsive-slide {
			flex-basis: auto;
			margin-right: 1px;
			margin-bottom: 1px;
		}
	}
}

.CarouselResponsive--xs {
	@include breakpoint(medium) {
		@supports (display: grid) {
			grid-template-columns: repeat(auto-fill, minmax(8rem, 1fr));
		}
	}
	.CarouselResponsive-slide {
		flex: 0 0 8rem;
		@include breakpoint(medium) {
			flex: 0 0 8rem;
		}
	}
	.CarouselResponsive-slide img {
		max-height: 8rem;
		@include breakpoint(medium) {
			max-height: 8rem;
		}
	}
}

.CarouselResponsive--sm {
	@include breakpoint(medium) {
		@supports (display: grid) {
			grid-template-columns: repeat(auto-fill, minmax(12rem, 1fr));
		}
	}
	.CarouselResponsive-slide {
		flex: 0 0 12rem;
		@include breakpoint(medium) {
			flex: 0 0 12rem;
		}
	}
	.CarouselResponsive-slide img {
		max-height: 12rem;
		@include breakpoint(medium) {
			max-height: 12rem;
		}
	}
}

.CarouselResponsive--md {
	@include breakpoint(medium) {
		@supports (display: grid) {
			grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr));
		}
	}
	.CarouselResponsive-slide {
		flex: 0 0 16rem;
		@include breakpoint(medium) {
			flex: 0 0 16rem;
		}
	}
	.CarouselResponsive-slide img {
		max-height: 16rem;
		@include breakpoint(medium) {
			max-height: 16rem;
		}
	}
}

.CarouselResponsive--lg {
	@include breakpoint(medium) {
		@supports (display: grid) {
			grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));
		}
	}
	.CarouselResponsive-slide {
		flex: 0 0 20rem;
		@include breakpoint(medium) {
			flex: 0 0 20rem;
		}
	}
	.CarouselResponsive-slide img {
		max-height: 20rem;
		@include breakpoint(medium) {
			max-height: 20rem;
		}
	}
}

.CarouselResponsive--xl {
	@include breakpoint(medium) {
		@supports (display: grid) {
			grid-template-columns: repeat(auto-fill, minmax(24rem, 1fr));
		}
	}
	.CarouselResponsive-slide {
		flex: 0 0 24rem;
		@include breakpoint(medium) {
			flex: 0 0 24rem;
		}
	}
	.CarouselResponsive-slide img {
		max-height: 24rem;
		@include breakpoint(medium) {
			max-height: 24rem;
		}
	}
}

.CarouselResponsive--sm-width80 {
	@include breakpoint(medium, down) {
		.CarouselResponsive-slide {
			flex: 1 0 85%;
		}
		.CarouselResponsive-slide img {
			max-height: none;
		}
	}
}

.CarouselResponsive--sm-widthFull {
	@include breakpoint(medium, down) {
		.CarouselResponsive-slide {
			flex: 1 0 100%;
		}
		.CarouselResponsive-slide img {
			max-height: none;
		}
	}
}

.CarouselResponsive--md-size1of3 {
	@include breakpoint(medium) {
		@supports (display: grid) {
			grid-template-columns: 3fr 3fr 3fr;
		}
	}
}

.CarouselResponsive--md-size1of4 {
	@include breakpoint(medium) {
		@supports (display: grid) {
			grid-template-columns: 4fr 4fr 4fr 4fr;
		}
	}
}

.CarouselResponsive--lg-size1of3 {
	@include breakpoint(large) {
		@supports (display: grid) {
			grid-template-columns: 3fr 3fr 3fr;
		}
	}
}

.CarouselResponsive--lg-size1of4 {
	@include breakpoint(large) {
		@supports (display: grid) {
			grid-template-columns: 4fr 4fr 4fr 4fr;
		}
	}
}

// crops to 4:3 for desktop in a hero showcase grid
.CarouselResponsive--showcase {
	background-color: $color-white;
	.CarouselResponsive-slide {
		background-color: $color-neutral-5;
		margin-right: 1px;
		[dir='rtl'] & {
			margin-right: 0;
			margin-left: 1px;
		}
		.Media,
		.Media-content {
			height: 100%;
		}
		&:nth-child(n + 2) {
			.Media-caption {
				@include text(1);
				font-weight: bold;
				.Icon--photo,
				.Icon--audio,
				.Icon--video {
					width: 16px;
					height: 16px;
				}
			}
		}
		a:focus {
			img {
				border: 2px solid $color-link;
			}
		}
	}
	@include breakpoint(medium) {
		height: auto;
		.CarouselResponsive-slide {
			margin: 0;
			&:nth-child(n + 6) {
				display: none;
			}
			.Media,
			.Media-content {
				height: 100%;
			}
			.Media-caption--moreOverlay {
				top: 0;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 1.5rem !important;
				pointer-events: none;
				.Icon {
					display: none;
				}
			}
		}
		@supports (display: grid) {
			gap: 1px;
			grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
			grid-template-rows: 1fr 1fr 1fr 1fr;
			.CarouselResponsive-slide {
				margin: 0;
				&:first-child {
					grid-row: 1 / 5;
					grid-column: 1 / 5;
				}
			}
		}
	}
}

// --showcaseMultimedia assumes that the last 2 slides are video and audio
// and on desktop, we need to show them, and hide the photos in the middle
.CarouselResponsive--showcaseMultimedia {
	@include breakpoint(medium) {
		.CarouselResponsive-slide {
			&:nth-child(n + 6) {
				display: initial;
			}
		}
	}
}
</style>
